<template>
  <div class="wrapper">
    <Transition>
      <div
        v-if="isOpenSidebar || isOpenFormSidebar"
        class="overlay overlay--header-dropdown"
        @click="closeSidebar(), closeFormSidebar()"
      />
    </Transition>
    <PrimaryHeader @openSidebar="openSidebar" />
    <PrimaryHeaderSticky />
    <main>
      <Nuxt @open-popup="openPopup()" @close-popup="closePopup()" />
    </main>
    <LazyHydrate when-visible>
      <LazyFooterMobile />
    </LazyHydrate>
    <ExternalIntegrations />

    <LazyHydrate never :trigger-hydration="isOpenSidebar">
      <Transition name="slide">
        <LazySidebarMenu v-if="isOpenSidebar" @closeSidebar="closeSidebar" />
      </Transition>
    </LazyHydrate>

    <div
      class="popmechanic-disable-flag"
      :class="{
        true:
          isOpenFormSidebar ||
          isOpenSidebar ||
          isShowCreateMeeting ||
          isAutotest,
      }"
    />
  </div>
</template>
<script>
import LazyHydrate from 'vue-lazy-hydration'
import { isNoindexNofollow } from '@/helpers/pageData'
import { scrollToSection } from '@/helpers/common'
import EventBus from '@/mixins/EventBus'
import ExternalIntegrations from '@/components/Common/ExternalIntegrations/ExternalIntegrations.vue'
import LazyFooterMobile from '~/components/Mobile/Footer/Lazy/LazyFooterMobile.vue'
import LazySidebarMenu from '@/components/NewDesign/Layout/Primary/Sidebar/LazySidebarMenu.vue'
import PrimaryHeader from '@/components/NewDesign/Layout/Primary/Header/PrimaryHeader.vue'
import PrimaryHeaderSticky from '@/components/NewDesign/Layout/Primary/Header/PrimaryHeaderSticky.vue'
import getCanonical from '@/helpers/getCanonical'

export default {
  name: 'primary-mobile',
  components: {
    LazySidebarMenu,
    LazyFooterMobile,
    ExternalIntegrations,
    PrimaryHeaderSticky,
    PrimaryHeader,
    LazyHydrate,
  },
  mixins: [EventBus],
  data() {
    return {
      form: '',
      isOpenSidebar: false,
      isOpenPopup: false,
      isOpenFormSidebar: false,
      isShowCreateMeeting: false,
      isAutotest: false,
      isABTestEnabled: false,
      abFormSelectorVariant: '0',
      formName: undefined,
    }
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.generateLdPlusJSON()),
          type: 'application/ld+json',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: getCanonical(this.$route.path),
        },
      ],
      meta: [
        ...(isNoindexNofollow(this.$route.path)
          ? [{ name: 'robots', content: 'noindex, nofollow' }]
          : []),
      ],
      bodyAttrs: {
        class: this.isOpenFormSidebar || this.isOpenSidebar ? 'no-scroll' : '',
      },
    }
  },
  watch: {
    '$route.path'() {
      this.closeSidebar()
    },
  },
  mounted() {
    if (this.$route.query.autotest === '1') {
      this.isAutotest = true
    }

    this.$nextTick(() => {
      const hash = this.$route.hash
      if (hash) {
        scrollToSection(hash)
      }
    })
  },
  methods: {
    openSidebar() {
      this.isOpenSidebar = true
    },
    closeSidebar() {
      this.isOpenSidebar = false
    },

    __onShowFormSidebar(params) {
      this.isOpenFormSidebar = true
      this.form = params.form
      this.header = params.header
      this.isABTestEnabled = params?.params?.isABTestEnabled
      this.formName = params?.params?.formName
    },

    closeFormSidebar() {
      this.isOpenFormSidebar = false
    },

    openPopup() {
      this.isShowCreateMeeting = true
    },

    closePopup() {
      this.isShowCreateMeeting = false
    },

    generateLdPlusJSON() {
      return {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: 'МТС Линк',
        alternateName: 'МТС Линк',
        url: 'https://mts-link.ru' + this.$route.path,
        logo: 'https://mts-link.ru/_nuxt/img/mts-link.svg',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  overflow-x: hidden;
}

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 499;
  background-color: rgba(29, 32, 35, 0.4);
  backdrop-filter: blur(4px);
  transition: 0.3s;
}

.v-enter {
  opacity: 0;
}

.v-leave-to {
  opacity: 0;
  visibility: hidden;
}

.slide-enter-active {
  transform: translateX(100%);
  transition: all 0.2s ease-out;
}

.slide-leave-active {
  transition: all 0.2s ease-out;
}

.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
